import { createApp } from 'vue'
import App from '../public/App.vue'


createApp(App).mount('#app')

window.addEventListener("DOMContentLoaded", () => {
    const fadeOut = () => {
        const loaderWrapper = document.querySelector('.wrapper');
        loaderWrapper ? loaderWrapper.classList.add('fade') : null;
    };


    window.addEventListener('load', fadeOut);
});


